import React, { useState } from "react";

import { keylessColors } from "../../utils";
import { KeylessModal } from "../../components/KeylessModal";
import { KeylessButton } from "../../components/KeylessButton";
import { ReactComponent as MapGuerinSvg } from "../../../../assets/images/keyless-return/map-guerin.svg";
import whiteCarImg from "../../../../assets/images/keyless-return/white-car.svg";
import greenCarImg from "../../../../assets/images/keyless-return/green-car.svg";
import whiteLockImg from "../../../../assets/images/keyless-return/white-lock.svg";
import greenLockImg from "../../../../assets/images/keyless-return/green-lock.svg";

export const RETURN_STEPS = {
  START: 1,
  IN_PROGRESS: 2,
  FINISHED: 3,
};

export function KeylessReturnLayout({
  children,
  step,
  localizationAssets,
  contractNumber,
  t = () => "",
  footer,
  helpModalOpen,
  setHelpModalOpen
}) {
  return (
    <div style={styles.page}>
      <ReturnHeader
        currentStep={step}
        localizationAssets={localizationAssets}
      />
      <div style={styles.reservationLine}>
        <div style={{ opacity: contractNumber ? 1 : 0 }}>{contractNumber}</div>
        <div
          style={styles.reservationLineHelp}
          onClick={() => setHelpModalOpen(true)}
        >
          <div>{t("keylessReservationHelp")}</div>
          <img
            src={localizationAssets["keylessReservationHelp"]}
            style={styles.reservationLineHelpImg}
            alt=""
          />
        </div>
      </div>
      <div style={styles.card}>
        <div style={styles.children}>{children}</div>
        <div style={styles.footer}>{footer}</div>
      </div>
      <KeylessModal
        isOpen={helpModalOpen}
        title={t("keylessHelpTitle")}
        message={t("keylessHelpMessage")}
        animation="slide-up"
        img={localizationAssets["keylessReservationHelp"]}
        imgStyle={{ height: "35px", width: "35px" }}
        modalStyle={{ minHeight: "350px" }}
        actions={
          <KeylessButton
            text={t("keylessHelpClose")}
            onClick={() => setHelpModalOpen(false)}
          />
        }
      />
    </div>
  );
}

function PinIcon({ fill }) {
  return (
    <MapGuerinSvg style={{ color: fill, width: "20px", height: "26px" }} />
  );
}

function CarIcon({ fill }) {
  const isActive = fill === "#93C01F";
  return (
    <img
      src={isActive ? greenCarImg : whiteCarImg}
      alt=""
      width="28"
      height="22"
    />
  );
}

function LockIcon({ fill }) {
  const isActive = fill === "#93C01F";
  return (
    <img
      src={isActive ? greenLockImg : whiteLockImg}
      alt=""
      width="26"
      height="26"
    />
  );
}

function ReturnHeader({ currentStep, localizationAssets }) {
  const items = [
    { step: RETURN_STEPS.START, icon: PinIcon },
    { step: RETURN_STEPS.IN_PROGRESS, icon: CarIcon },
    { step: RETURN_STEPS.FINISHED, icon: LockIcon },
  ];

  return (
    <div style={styles.header}>
      <img
        src={localizationAssets["keylessGuerinLogo"]}
        alt="Guerin"
        style={styles.logo}
        height="60px"
        width="80px"
      />
      <div style={styles.breadcrumbs}>
        {items.map((item, index) => {
          const isActive = currentStep >= item.step;
          const isCompleted = currentStep > item.step;
          const IconComponent = item.icon;
          return (
            <React.Fragment key={item.step}>
              <div
                style={
                  isActive ? styles.breadcrumbItemActive : styles.breadcrumbItem
                }
              >
                <IconComponent fill={isActive ? "#93C01F" : "white"} />
              </div>
              {index < items.length - 1 && (
                <div
                  style={
                    isCompleted
                      ? styles.breadcrumbLineActive
                      : styles.breadcrumbLine
                  }
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

export const styles = {
  page: {
    height: "100dvh",
    display: "flex",
    flexDirection: "column",
    fontFamily: "'BlissLight'",
    backgroundColor: "#FFFFFF",
  },
  header: {
    backgroundColor: keylessColors.green,
    display: "flex",
    alignItems: "center",
    padding: "20px 15px",
    gap: "2rem",
  },
  logo: {
    width: "80px",
  },
  breadcrumbs: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  breadcrumbItemActive: {
    backgroundColor: "white",
    borderRadius: "50%",
    height: "50px",
    width: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  breadcrumbItem: {
    backgroundColor: "#D9D9D9",
    borderRadius: "50%",
    height: "50px",
    width: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  breadcrumbLine: {
    backgroundColor: "#D9D9D9",
    height: "10px",
    flex: "1",
  },
  breadcrumbLineActive: {
    backgroundColor: "white",
    height: "10px",
    flex: "1",
  },
  reservationLine: {
    backgroundColor: "#F0F0F0",
    padding: "12px 15px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  reservationLineHelp: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    color: "#FD812A",
  },
  reservationLineHelpImg: {
    height: "25px",
  },
  card: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    margin: "20px 15px",
    borderRadius: "12px",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
    overflow: "hidden",
  },
  children: {
    flex: "1",
    display: "flex",
    overflow: "auto",
  },
  footer: {
    padding: "15px",
  },
};
